module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_122-04eb00deb190fd0fe391a04fc76573cd.png";